// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vpn{padding:10px}.vpn figure{display:block;margin-top:20px}.vpn figure figcaption{font-size:1.4rem;margin-top:5px;opacity:.55}.vpn figure img{display:inline-block;max-width:100%}.vpn h1{margin-bottom:32px}.vpn ol{display:inline-block;margin-left:20px}.vpn ol li{margin:20px 0}.vpn ol ul{margin-left:20px}.vpn ol ul li,.vpn ol ul p{margin:5px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
